import styled from 'styled-components'

const TimeOffsetStyled = styled.div`
  h4 {
    margin-bottom: 0.5rem;
  }
`
export default TimeOffsetStyled
